import { createSlice } from "@reduxjs/toolkit";
// import { getMRZ } from "libs/utils/mrzUtils";
import MRZService from "services/MRZService";

let initialState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  ocrText: "",
  format: "",
  detail: {
    // countryCode: "",
    // firstName: "",
    // lastName: "",
    birthDate: "",
    birthDateCheckDigit: "",
    compositeCheckDigit: "",
    documentCode: "",
    documentNumber: "",
    documentNumberCheckDigit: "",
    expirationDate: "",
    expirationDateCheckDigit: "",
    firstName: "",
    issuingState: "",
    lastName: "",
    nationality: "",
    personalNumber: "",
    personalNumberCheckDigit: "",
    sex: "",
  },
};

const passportSlice = createSlice({
  name: "passport",
  initialState,
  reducers: {
    clearPassportState(state) {
      state.isLoading = false;
      state.isSuccess = false;
      state.isFailure = false;
    },
    readOCRRequest(state, action) {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFailure = false;
      state.error = initialState.error;
    },
    readOCRSuccess(state, action) {
      state.isLoading = false;
      state.isSuccess = true;
      // state.ocrText = typeof action.payload === "string" ? action.payload : "";

      // const mrzDetail = getMRZ(state.ocrText);

      // state.detail.countryCode = mrzDetail.countryCode;
      // state.detail.firstName = mrzDetail.firstName;
      // state.detail.lastName = mrzDetail.lastName;

      state.detail = action.payload?.fields || {};
      state.format = action.payload?.format || "";
    },
    readOCRFailure(state, action) {
      state.isLoading = false;
      state.isFailure = true;
      state.error = action.payload;
    },
  },
});

export const {
  readOCRRequest,
  readOCRSuccess,
  readOCRFailure,
  clearPassportState,
} = passportSlice.actions;

// ======== Thunk Action ==========

export function readOCRPassport(file) {
  return async (dispatch) => {
    dispatch(readOCRRequest());

    try {
      const response = await MRZService.read(file);
      const results = response?.data || {};
      dispatch(readOCRSuccess(results));
    } catch (error) {
      dispatch(readOCRFailure(error.message));
      throw error;
    }
  };
}

export const selectPassportState = (state) => state.passport;

export default passportSlice.reducer;
